import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { createMonthDepreciation, lockMonthDepreciation, getCreateMonthData } from '../../../services/asset.service';
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import '../AssetInfo/UserAssetDepreciation.css';

import * as CryptoJS from "crypto-js";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LockIcon from '@mui/icons-material/Lock';
import InfoIcon from '@mui/icons-material/Info';

export default function UserAssetDepreciation() {
  const errRef = useRef();
  const [errMsg, setErrMsg] = useState('');
  const [success, setSuccess] = useState('');
  const [fnSession, setFnSession] = useState('');
  const [ErrSession, setErrSession] = useState('');
  const [month, setMonth] = useState('');
  const [items, setItems] = useState([]);
  const [monthsData, setMonthsData] = useState({
    april: null,
    may: null,
    june: null,
    july: null,
    august: null,
    september: null,
    october: null,
    november: null,
    december: null,
    january: null,
    february: null,
    march: null
  });

  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const Tag = query.get('tag');
  const Previous = query.get('previous');

  useEffect(() => {
    if (Previous && Previous !== '') {
      const decryptedBytes = CryptoJS.AES.decrypt(
        Previous.replace(/ /g, '+'),
        process.env.REACT_APP_ENCRYPT_SECRET_KEY
      );
      const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
      
      let year = parseInt(decrypt_data?.finance_year, 10);
      let month = parseInt(decrypt_data?.finance_month, 10);

      if (month === 1) {
        month = 12;
        year = year - 1;
      } else if (month === 2 || month === 3) {
        year = year - 1;
      } else {
        month = month - 1;
      }
      
      setMonth(month);
      setFnSession(year);
      handleFinancialYearByValue(year);
    }
    setErrSession('');
  }, [Previous]);

  useEffect(() => {
    if (items?.length) {
      setMonthsData({
        april: items.find(obj => obj.month == 4),
        may: items.find(obj => obj.month == 5),
        june: items.find(obj => obj.month == 6),
        july: items.find(obj => obj.month == 7),
        august: items.find(obj => obj.month == 8),
        september: items.find(obj => obj.month == 9),
        october: items.find(obj => obj.month == 10),
        november: items.find(obj => obj.month == 11),
        december: items.find(obj => obj.month == 12),
        january: items.find(obj => obj.month == 1),
        february: items.find(obj => obj.month == 2),
        march: items.find(obj => obj.month == 3)
      });
    } else {
      setMonthsData({
        april: null, may: null, june: null, july: null,
        august: null, september: null, october: null, november: null,
        december: null, january: null, february: null, march: null
      });
    }
  }, [items]);

  const handleFinancialYear = (e) => {
    handleFinancialYearByValue(e.target.value);
  };

  const handleFinancialYearByValue = (value) => {
    if (value !== '') {
      setFnSession(value);
      setErrSession('');
      
      var obj = {
        'fy_year': parseInt(value) + '-' + (parseInt(value) + 1),
        'token': sessionStorage.getItem('LoggedInToken'),
      };
      
      let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
        'param_data': obj,
        'authToken': sessionStorage.getItem('LoggedInToken'),
      }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
      
      let oData = { 'token': EncryptData }
      
      getCreateMonthData(oData).then(res => {
        if (res?.data?.data?.res?.length) {
          setItems(res.data.data.res);
        } else {
          setItems([]);
        }
      });
    } else {
      setErrSession('Please Select Financial Year')
    }
  }

  const clickMonthTable = (e) => {
    e.preventDefault();
    let value = e.currentTarget.getAttribute('data-month');

    if (fnSession !== '' && value !== '') {
      var session = fnSession;
      if (value == "1" || value == "2" || value == "3") {
        session = (parseInt(fnSession) + 1);
      }
      setErrSession('');
      
      let EncryptID = CryptoJS.AES.encrypt(JSON.stringify({
        'finance_month': value,
        'finance_year': session,
        'back_url': 'user-asset-depreciation'
      }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
      
      window.location.href = "/generate-depreciation?finance=" + EncryptID;
    } else {
      setErrSession('Please Select Financial Year')
    }
  }

  const MonthCard = ({ month, monthName, monthValue, data }) => {
    const isLocked = data?.lock_status === 'Y';
    const isCreated = !!data;

    return (
      <div className="col-lg-12 col-md-4 col-sm-6 mb-4">
        <div className={`user-month-card ${isLocked ? 'locked' : isCreated ? 'created' : 'pending'}`}>
          {isLocked ? (
            <div className="user-month-card-locked">
              <div className="user-month-icon-container">
                <LockIcon className="lock-icon-large" />
              </div>
              <h3 className="user-month-name">{monthName}</h3>
              <div className="locked-badge">
                <LockIcon fontSize="small" />
                <span>Locked</span>
              </div>
            </div>
          ) : isCreated ? ( <a data-month={month}
              onClick={clickMonthTable}
              href="#"
              className="user-month-link">
              <div className="user-month-card-active">
                <div className="user-month-icon-container">
                  <CalendarMonthIcon className="calendar-icon-large" />
                </div>
                <h3 className="user-month-name">{monthName}</h3>
                <div className="created-badge">
                  <CheckCircleIcon fontSize="small" />
                  <span>Available</span>
                </div>
                <div className="view-hint">
                  <i className="bi bi-arrow-right-circle"></i>
                  Click to view
                </div>
              </div>
            </a>
          ) : (
            <div className="user-month-card-pending">
              <div className="user-month-icon-container opacity-50">
                <CalendarMonthIcon className="calendar-icon-large" />
              </div>
              <h3 className="user-month-name">{monthName}</h3>
              <div className="pending-badge">
                <InfoIcon fontSize="small" />
                <span>Not Available</span>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className='user-depreciation-container'>
      {/* Header Section */}
      <div className='user-page-header'>
        <div className='user-header-content'>
          <div className='user-header-left'>
            <div className='user-header-icon'>
              <CalendarMonthIcon style={{ fontSize: '2rem' }} />
            </div>
            <div>
              <h3 className='user-page-title'>View Depreciation</h3>
              <p className='user-page-subtitle'>Access monthly depreciation records</p>
            </div>
          </div>
        </div>

        {/* Alert Messages */}
        {success && (
          <div className="user-alert-success">
            <CheckCircleIcon />
            <span>{success}</span>
          </div>
        )}
        {errMsg && (
          <div className="user-alert-danger">
            <i className="bi bi-exclamation-triangle-fill"></i>
            <span>{errMsg}</span>
          </div>
        )}
      </div>

      {/* Financial Year Selection */}
      <div className='user-fy-selection-card'>
        <div className='user-fy-selection-header'>
          <h4>
            <i className="bi bi-calendar3"></i>
            Select Financial Year
          </h4>
          <p className="user-fy-subtitle">Choose a financial year to view available months</p>
        </div>
        <div className='user-fy-selection-body'>
          <div className='user-fy-input-group'>
            <select
              onChange={handleFinancialYear}
              value={fnSession}
              className="user-fy-select"
            >
              <option value="">Select Financial Year</option>
              {[...Array(20)].map((_, i) => {
                const year = 2025 - i;
                return (
                  <option key={year} value={year}>
                    FY {year}-{(year + 1).toString().substr(-2)}
                  </option>
                );
              })}
            </select>
            <button
              onClick={() => handleFinancialYear({ target: { value: fnSession } })}
              className="user-btn-fetch"
              disabled={!fnSession}
            >
              <i className="bi bi-search"></i>
              Fetch Data
            </button>
          </div>
          {ErrSession && <span className="user-error-message">{ErrSession}</span>}
        </div>
      </div>

      {/* Info Banner */}
      {fnSession && (
        <div className='user-info-banner'>
          <div className="user-info-icon">
            <InfoIcon />
          </div>
          <div className="user-info-content">
            <strong>Financial Year {fnSession}-{parseInt(fnSession) + 1}</strong>
            <p>Green cards indicate available months. Click on any green card to view depreciation details.</p>
          </div>
        </div>
      )}

      {/* Legend */}
      {fnSession && (
        <div className='user-legend-card'>
          <div className='legend-item'>
            <div className='legend-color available'></div>
            <span>Available - Click to View</span>
          </div>
          <div className='legend-item'>
            <div className='legend-color locked'></div>
            <span>Locked - Cannot Modify</span>
          </div>
          <div className='legend-item'>
            <div className='legend-color pending'></div>
            <span>Not Available</span>
          </div>
        </div>
      )}

      {/* Months Grid */}
      <div className='user-months-grid'>
        <MonthCard month="4" monthName="April" monthValue="04" data={monthsData.april} />
        <MonthCard month="5" monthName="May" monthValue="05" data={monthsData.may} />
        <MonthCard month="6" monthName="June" monthValue="06" data={monthsData.june} />
        <MonthCard month="7" monthName="July" monthValue="07" data={monthsData.july} />
        <MonthCard month="8" monthName="August" monthValue="08" data={monthsData.august} />
        <MonthCard month="9" monthName="September" monthValue="09" data={monthsData.september} />
        <MonthCard month="10" monthName="October" monthValue="10" data={monthsData.october} />
        <MonthCard month="11" monthName="November" monthValue="11" data={monthsData.november} />
        <MonthCard month="12" monthName="December" monthValue="12" data={monthsData.december} />
        <MonthCard month="1" monthName="January" monthValue="01" data={monthsData.january} />
        <MonthCard month="2" monthName="February" monthValue="02" data={monthsData.february} />
        <MonthCard month="3" monthName="March" monthValue="03" data={monthsData.march} />
      </div>
    </div>
  )
}